module.exports = __webpack_public_path__ + "img/ic_person_search.0e5660c4.svg";